import React, { use, useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types"

import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// import logo from './assets/images/invoicelogo.png';
import logo from "./../assets/images/invoicelogo.png";
import { getInvoiceId, saveGeneratedInvocie } from "helpers/fakebackend_helper";
import SweetAlert from "react-bootstrap-sweetalert";
import { getOrderPrefix } from "helpers/common_helper";
// import { fontFamily } from "html2canvas/dist/types/css/property-descriptors/font-family";

// const html2pdf = require('html2pdf.js');


// import React, { useRef } from "react";


/**
 * Invoice.jsx — React (JS) single-file component
 * - Clean, printable invoice layout with TailwindCSS
 * - Works with any data via props; falls back to demo data
 * - Buttons: Print, Download (via print dialog), and simple share (copy)
 * - Auto-calculates subtotal, tax, discount, and grand total
 *
 * Usage:
 * <Invoice data={yourInvoiceObject} />
 */

const currency = (n, c = "USD", l = "en-US") =>
  new Intl.NumberFormat(l, { style: "currency", currency: c }).format(Number(n || 0));

const DemoData = {
  meta: {
    invoiceNo: "INV-2025-0007",
    issueDate: "2025-08-29",
    dueDate: "2025-09-15",
    status: "Unpaid",
    currency: "USD",
  },
  from: {
    
    name: "EMB EXPERT",
    // address: "123 Market Street, Floor 5, San Francisco, CA 94103",
    website: "www.embexpert.net",
    email: "orders@embexpert.net",
    phone: "843-353-4577",
  },
  to: {
    name: "Contoso Ltd.",
    address: "77 King Street, London SW1A 1AA, UK",
    email: "ap@contoso.com",
    phone: "+44 20 7946 0958",
  },
  items: [],
  summary: {
    taxRatePct: 0,
    discount: 0,
    notes: "Thanks for your business!",
    terms: "Please reference invoice number on all payments.",
  },
};
const Invoice = props => {
  // export default function Invoice({ data = DemoData }) {
  const { processData, invoiceItems,invoiceData, isPublic } = props;

  
  const { meta, from, to, items, summary } = DemoData;
  const [lineDetails, setLineDetails] = useState({ sub: 0, tax: 0, discount: 0, grand: 0 });
  const [uniqueId, setUniqueId] = useState(Date.now( new Date().toLocaleString("en-US", { timeZone: "America/Chicago" })).toString())
  const [alert, setAlert] = useState(false)

  const totals = useMemo(() => {
    console.log("=====", processData,invoiceItems, invoiceData,isPublic)
    const sub = (invoiceItems || []).reduce((acc, it) => acc + (Number(it.processingData.price)), 0);
    const tax = sub * (Number(summary?.taxRatePct || 0) / 100);
    const discount = (invoiceItems || []).reduce((acc, it) => acc + (Number(it.processingData.discount)), 0);
    const grand = Math.max(sub + tax - discount, 0);
    return { sub, tax, discount, grand };
  }, [items, summary,invoiceItems]);

  useEffect(() => {
    setLineDetails(totals);
  }, [totals]);

  const onPrint = () => window.print();

  const onCopyShare = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      alert("Link copied to clipboard");
    } catch (e) {
      alert("Couldn't copy link");
    }
  };

  const StatusPill = ({ status = "Draft" }) => {
    const colors = {
      Paid: "status-paid",
      Unpaid: "status-unpaid",
      Overdue: "status-overdue",
      Draft: "status-draft",
    };
    const cls = colors[status] || colors.Draft;
    return <span className={`status-pill ${cls}`}>{status}</span>;
  };
  const invoiceRef = useRef();

  const handlePrint = () => {
    const printContent = invoiceRef.current.innerHTML;
    const WinPrint = window.open("", "", "width=900,height=650");
    WinPrint.document.write(`
      <html>
        <head>
          <title>Invoice</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 20px;
              background: #fff;
            }
            .invoice-container {
              width: 100%;
              max-width: 800px;
              margin: auto;
              padding: 20px;
              border: 1px solid #ddd;
              background: #fff;
            }
            h1, h2, h3 {
              margin: 0;
              padding-bottom: 5px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            table th, table td {
              border: 1px solid #ddd;
              padding: 10px;
              text-align: left;
            }
            table th {
              background: #f4f4f4;
            }
            .total {
              text-align: right;
              font-weight: bold;
              margin-top: 20px;
            }

            /* PRINT STYLES */
            @media print {
              body {
                margin: 0;
                padding: 0;
                background: #fff;
              }
              .invoice-container {
                border: none;
                box-shadow: none;
                margin: 0;
                width: 100%;
                padding: 0;
              }
              .no-print {
               # display: none !important;
              }
            }
          </style>
        </head>
        <body>
          ${printContent}
        </body>
      </html>
    `);
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  };


  useEffect(() => {
    if(isPublic && invoiceData.hasOwnProperty("timestamp")){
      invoiceId();
    }else{
      // setUniqueId(Date.now( new Date().toLocaleString("en-US", { timeZone: "America/Chicago" })).toString());
    }
    
  }, [invoiceData])

  const invoiceId = () => {
      if(!isPublic){
        setUniqueId(Date.now( new Date().toLocaleString("en-US", { timeZone: "America/Chicago" })).toString());
      }
      else{
        setUniqueId(invoiceData.timestamp)
      }
      
  }

  const onInvoiceSubmit = () => {
    const data = {}
    const orders = []
    // rec.inv = (invoiceItems || []).map(it => ({
    invoiceItems.map((it, idx) => {
      const rec = {};
      rec.orderNo = it.orderCode || it.orderNo
      rec.propId = it.submitDateTime
      rec.submitDateTime = it.submitDateTime
      rec.requestFor = it.requestFor
      rec.sentDate = it.sentDate ? new Date(it.sentDate) : new Date()
      rec.price = it.processingData.price
      rec.orderName = it.orderName
      rec.discount = it.processingData.discount
      rec.totalPrice = it.processingData.totalPrice
      rec.orderId = it._id 
      rec.id = idx + 1
      rec.po = it.processingData.po || ""
      orders.push(rec)
    })
    data.timestamp = uniqueId;
    data.fb_Id = ""
    data.company = processData?.company
    data.contactPerson = processData?.contactPerson
    data.authEmail = processData?.email
    data.mauth_id = processData?._id
    data.inv = orders
    saveGeneratedInvocie(data).then(res => {
      setAlert(<SweetAlert
        // title="Success"
        success
        confirmBtnText = "OK"
        title={`Your Invoice Successfully Generated `}
        onConfirm={() => setAlert(false)}
        onCancel={()=> setAlert(false)}
        focusCancelBtn
      >Your invoice no is {uniqueId}</SweetAlert>)
    }).catch(err => {
      console.log("err", err)
    })
  }







  return (
    <div className="invoice-page" id="invoiceprint" ref={invoiceRef}>
      <div className="invoice-container" style={{ fontFamily: "sans-serif" }}>
        {alert}
        {/* Header */}
        <div className="invoice-header">
          <div className="invoice-title">
            <div >
              <img src={logo} alt="Logo" style={{ width: "70px", height: "80px", borderRadius: "8px" }} />
            </div>
            <div>
              <h1>Invoice</h1>
              <p>Invoice # : <b>{uniqueId}</b></p>
            </div>
          </div>
          <div className="invoice-actions">
            <StatusPill status={invoiceData.status ? "Paid" : "Unpaid"} />
            <button onClick={handlePrint}>Print / PDF</button>
            {!isPublic ? (<button onClick={onInvoiceSubmit}>GenerateInvoice</button>) : ""}
          </div>
        </div>

        {/* Parties & Dates */}
        <div className="invoice-parties">
          <div>
            <h2>Bill To</h2>
            <p>Company: {processData?.company}</p>
            <p>Name: {processData?.contactPerson}</p>
            {/* <p>{to?.address}</p> */}
            <p>Email: {processData?.email}</p>
            {/* <p>Phone: {processData?.phone}</p> */}
          </div>
          <div>
            <h2>Bill From</h2>
            <p>Company: {from?.name}</p>
            <p>Website: {from?.website}</p>
            <p>Email: {from?.email}</p>
            {/* <p>Phone: {from?.phone}</p> */}
          </div>
          
          {/* <div className="invoice-meta">
            <div><strong>Issue Date:</strong> {meta?.issueDate}</div>
            <div><strong>Due Date:</strong> {meta?.dueDate}</div>
            <div><strong>Currency:</strong> {meta?.currency || "USD"}</div>
          </div> */}
        </div>

        {/* Items */}
        <div className="invoice-items">
          <table>
            <thead>
              <tr>
                <th>S#</th>
                <th>Design No</th>
                <th>PO</th>
                <th>Design Name</th>
                <th>Payment Status</th>
                <th>Received Date</th>
                <th>Released Date</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              {(invoiceItems || []).map((it, idx) => {
                const amount = Number(1) * Number(it?.processingData.price);
                return (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{getOrderPrefix(it.requestFor)}{it.orderCode || it.orderNo}</td>
                    <td>{it.po}</td>
                    <td>{it.orderName || "—"}</td>
                    <td>{invoiceData.status ? "Paid" : "Payable"}</td>
                    <td>  {new Date(it.submitDateTime).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  })}</td>
                    <td>  {new Date(it.sentDate).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  })}</td>
                    <td>{currency(it?.processingData.price, meta?.currency)}</td>
                  </tr>
                );
              })}
              {(items || []).length === 0 && (
                <tr>
                  <td colSpan={6} className="no-items">No items</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Summary */}
        <div className="invoice-summary">
          <div className="notes">
            {summary?.notes && (
              <>
                <h3>Notes</h3>
                <p>{summary.notes}</p>
              </>
            )}
            {summary?.terms && (
              <>
                <h3>Terms</h3>
                <p>
                  {summary.terms}
                </p>
              </>
            )}
          </div>

          <div className="totals">
            <Row label="Subtotal" value={currency(lineDetails.sub, meta?.currency)} />
            <Row label={`Tax (${Number(summary?.taxRatePct || 0)}%)`} value={currency(lineDetails.tax, meta?.currency)} />
            <Row label="Discount" value={`- ${currency(lineDetails.discount, meta?.currency)}`} />
            <hr />
            <Row label="Total" value={currency(lineDetails.grand, meta?.currency)} bold />
          </div>
        </div>

        {/* Footer */}
        <div className="invoice-footer" style={{ fontFamily: "Times New Roman" }}>
          Generated by Invoice.jsx — Print this page to save as PDF.
        </div>
      </div>

      {/* Inline CSS */}
      <style>{`
        .invoice-page { background: #f9fafb; padding: 20px; min-height: 100vh; font-family: sans-serif; color: #111; }
        .invoice-container { font-family: Arial, Helvetica, sans-serif; max-width: 900px; margin: auto; background: #fff; border: 1px solid #ddd; border-radius: 12px; overflow: hidden; }
        .invoice-header { display: flex; justify-content: space-between; align-items: center; padding: 20px; border-bottom: 1px solid #ddd; }
        .invoice-title { display: flex; align-items: center; gap: 10px; }
        .invoice-logo { width: 48px; height: 48px; border-radius: 12px; background: #111; color: #fff; display: flex; align-items: center; justify-content: center; font-weight: 900; }
        .invoice-actions button { margin-left: 10px; padding: 6px 12px; border: 1px solid #ccc; border-radius: 8px; background: #fafafa; cursor: pointer; }
        .invoice-parties { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; padding: 20px; }
        .invoice-meta { grid-column: span 2; display: flex; gap: 20px; margin-top: 10px; }
        .invoice-items { padding: 0 20px 20px; }
        table { width: 100%; border-collapse: collapse; }
        th, td { padding: 10px; border-top: 1px solid #ddd; text-align: left; }
        th { background: #f5f5f5; }
        .no-items { text-align: center; padding: 30px; color: #666; }
        .invoice-summary { display: flex; justify-content: space-between; padding: 20px; gap: 20px; }
        .notes { flex: 1; }
        .totals { flex: 1; background: #f9f9f9; border: 1px solid #ddd; border-radius: 12px; padding: 15px; }
        .invoice-footer { padding: 15px; background: #f9f9f9; font-size: 12px; text-align: center; border-top: 1px solid #ddd; }

        .status-pill { padding: 4px 12px; border-radius: 9999px; font-size: 12px; font-weight: 600; }
        .status-paid { background: #d1fae5; color: #065f46; }
        .status-unpaid { background: #fef3c7; color: #92400e; }
        .status-overdue { background: #fee2e2; color: #991b1b; }
        .status-draft { background: #f3f4f6; color: #374151; }
        
          img {
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: -2px center; /* moves content left by 2px */
}
        
      `}</style>
    </div>
  );

  function Row({ label, value, bold }) {
    return (
      <div className="row">
        <span className={bold ? "label bold" : "label"}>{label}</span>
        <span className={bold ? "value bold" : "value"}>{value}</span>
        <style>{`
        .row { display: flex; justify-content: space-between; margin: 5px 0; font-size: 14px; }
        .label { color: #555; }
        .value { font-weight: 500; }
        .bold { font-weight: 700; color: #111; }
      `}</style>
      </div>
    );
  }
}





Invoice.propTypes = {
  data: PropTypes.object,
  status: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  bold: PropTypes.bool,
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  processData: PropTypes.object,
  invoiceItems: PropTypes.array,
  invoiceData: PropTypes.object,
  isPublic: PropTypes.bool
}
export default Invoice
